export default "__VITE_ASSET__BNpJ7eMc__"